import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav } from "reactstrap";

export const SettingsDropdown = ({ logout }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(!dropdownOpen);

    return (
        <Nav navbar className="header-dropdown">
            <Dropdown nav className="fill-width" isOpen={dropdownOpen} toggle={toggle} style={{ zIndex: 1051 }}>
                <DropdownToggle nav>
                    <i className="fa fa-gear" style={{ fontSize: 26, color: '#234d80' }}></i>
                </DropdownToggle>

                <DropdownMenu end style={{ minWidth: 'max-content' }}>
                    <DropdownItem onClick={logout}>
                        <i className="fa-solid fa-right-from-bracket" style={{ fontSize: 16, marginRight: 10 }}/>
                        Log out
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </Nav>
    )
}
